import {
    POST,
    GET
} from "../util";
const whitelistUrl = "api/whitelist/";
const url = {
    whitelisted: `${whitelistUrl}whitelisted`,
    unhandled: `${whitelistUrl}unhandled`,
    blacklisted: `${whitelistUrl}blacklisted`,
    modifyWhitelist: `${whitelistUrl}modifyWhitelist`,
    unhandledCount: `${whitelistUrl}unhandled/count`,
};
const whitelistApi = {
    whitelisted: (params = {}) => {
        return POST(url.whitelisted, params);
    },
    unhandled: (params = {}) => {
        return POST(url.unhandled, params);
    },
    blacklisted: (params = {}) => {
        return POST(url.blacklisted, params);
    },
    modifyWhitelist: (params = {}) => {
        return POST(url.modifyWhitelist, params);
    },
    unhandledCount: () => {
        return GET(url.unhandledCount);
    }
};
export {
    whitelistApi
};